import React from 'react';
import { useApp } from '../context/AppContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Heart, Send } from 'lucide-react';

const THANK_YOU_TEMPLATE_ID = 't7';

export function ThankYouPromptDialog({ onCompose }) {
  const { guests, thankYouPrompt, setThankYouPrompt } = useApp();
  const guest = guests.find(g => g.id === thankYouPrompt);
  if (!guest) return null;
  const sentAt = guest.thankYouSentAt ? new Date(guest.thankYouSentAt) : null;
  const hasEmail = (guest.email || '').includes('@');
  const close = () => setThankYouPrompt(null);

  return (
    <Dialog open onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="thank-you-prompt">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px]">
            <Heart className="w-4 h-4 text-rose-600" /> Send {guest.name.split(' ')[0]} a thank-you?
          </DialogTitle>
        </DialogHeader>
        <div className="text-[13px] text-stone-700 space-y-2">
          <p><b>{guest.name}</b> just moved to <b>In Editing</b> — the recording is done. This is the usual moment to send the thank-you letter.</p>
          {sentAt ? (
            <p className="text-[12px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2.5 py-1.5" data-testid="thank-you-already-sent">
              A thank-you was already sent on {sentAt.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}. You can send another or skip.
            </p>
          ) : !hasEmail ? (
            <p className="text-[12px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2.5 py-1.5" data-testid="thank-you-no-email">This guest has no email address on file — add one first.</p>
          ) : null}
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="ghost" onClick={close} data-testid="thank-you-skip">Not now</Button>
          <Button
            data-testid="thank-you-send"
            disabled={!hasEmail}
            onClick={() => { close(); onCompose(guest.id, THANK_YOU_TEMPLATE_ID); }}
            className="bg-rose-600 hover:bg-rose-700 text-white"
          >
            <Send className="w-3.5 h-3.5 mr-1.5" /> {sentAt ? 'Send again' : 'Open thank-you letter'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
